<template>
  <div
    id="container"
    :class="mainClass"
    class="container">
    <div class="content-wrap">
      <wep-header
        :is-enter="isEnter"
        :menu-seq="menuSeq"
        :router-name="routerName"
        :is-login="isLogin"
        :is-header-img="isHeaderImg"/>
      <router-view name="content" @fnInquiryPopup="fnInquiryPopup"/>
    </div>
    <wep-footer
      ref="wepFooter"
      :is-footer="isFooter"
      :is-contact="isContact"/>
  </div>
</template>
<script>
import WepHeader from '~pages/layouts/WepHeader.vue'
import WepFooter from '~pages/layouts/WepFooter.vue'

export default {
  name: 'DefaultLayout',
  components: { 'wep-header': WepHeader, 'wep-footer': WepFooter },
  data () {
    return {
    }
  },
  computed: {
    mainClass () {
      return this.$route.meta.mainClass
    },
    isEnter () {
      return this.$route.meta.isEnter
    },
    menuSeq () {
      return this.$route.meta.menuSeq
    },
    routerName () {
      return this.$route.name
    },
    isFooter () {
      let isFooter = true
      if (this.$route.name === 'index' && !window.vue.getStore('mmpAuth').state.isMain) {
        isFooter = false
      }
      return isFooter
    },
    isHeaderImg () {
      return this.$route.meta.isHeaderImg
    },
    isLogin () {
      let isLogin = false
      let tokenStore = window.vue.getStore('token')
      let rootStore = window.vue.getStore('root')

      if (rootStore !== null && rootStore.getters.getSession.authenticated && tokenStore.getters.getTokenAuth) {
        isLogin = false
      } else {
        isLogin = true
      }
      return isLogin
    },
    isContact () {
      return (this.$route.meta.isContact)
    }
  },
  created () {
  },
  methods: {
    fnInquiryPopup () {
      this.$refs.wepFooter.fnInquiryPopup(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/DefaultLayout.vue